module.exports = __webpack_public_path__ + "img/DO.65feabc9.svg";